document.addEventListener("DOMContentLoaded", function() {
    const transitionDiv = document.getElementById('page-transition');
    const container = document.getElementById('lottie-animation');
    const scriptTag = document.currentScript || document.querySelector('script[data-transition-json]');

    const animation = lottie.loadAnimation({
      container: container,
      renderer: 'canvas',
      loop: false,
      autoplay: false,
      path: scriptTag.dataset.transitionJson,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
        progressiveLoad: true
      }
    });
// Preload animation and reset to first frame
animation.addEventListener('data_ready', () => {
  animation.goToAndStop(0, true);
});
// Ajuste de velocidade (1 = normal)
animation.setSpeed(1.2);
  
    function playTransitionAndNavigate(url) {
      // Exibe overlay com fade CSS
      transitionDiv.classList.add('visible');
      animation.goToAndPlay(0, true);
      // Após delay, oculta overlay e navega para a nova página
      setTimeout(() => {
        transitionDiv.classList.remove('visible');
        window.location.href = url;
      }, 500);
    }
  
    document.querySelectorAll('a, button[data-href]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        let targetUrl;
        if (link.tagName === 'A') {
          targetUrl = link.href;
        } else if (link.dataset.href) {
          targetUrl = link.dataset.href;
        } else {
          return;
        }
  
        // Filtra só links internos e ignora links com target="_blank" ou anchors
        const isInternal = targetUrl.includes(window.location.hostname);
        const isAnchor = link.getAttribute('href').startsWith('#');
        const isNewTab = link.target === '_blank';
  
        if (isInternal && !isAnchor && !isNewTab) {
          e.preventDefault();
          playTransitionAndNavigate(targetUrl);
        }
      });
    });
  });
  